import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { AuthRoot } from './App';
import { applyTheme, readTheme } from './components/Header';
import reportWebVitals from './reportWebVitals';

// 2026-10-08 UI pass: the vendor portal is a separate public page; load its code only when a vendor link is opened.
const VendorPortalPage = lazy(() => import('./components/VendorPortalPage'));

// Apply the saved / system theme before first paint so sign-in screens match the user's choice (Header keeps it in sync after).
applyTheme(readTheme());

const path = window.location.pathname;
const vendorMatch = path.match(/^\/vendor\/([a-f0-9]{32})\/?$/i);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  vendorMatch
    ? <Suspense fallback={<div className="state-center" style={{ height: '100vh' }}><div className="spinner" /></div>}><VendorPortalPage token={vendorMatch[1]} /></Suspense>
    : <React.StrictMode>
        {/* 2026-10-07 accounts: AuthRoot = email + password sign-in (the only sign-in since 2026-10-12) */}
        <AuthRoot>
          <App />
        </AuthRoot>
      </React.StrictMode>
);

reportWebVitals();
